import { forwardRef } from "react";
import {
  PhoneInput,
  type PhoneInputProps,
  type PhoneInputRefType,
} from "react-international-phone";
import { twMerge } from "tailwind-merge";

export type InputPhoneNumberRef = PhoneInputRefType;
export type InputPhoneNumberProps = PhoneInputProps;

export const InputPhoneNumber = forwardRef<
  InputPhoneNumberRef,
  InputPhoneNumberProps
>(
  (
    { className, inputProps, countrySelectorStyleProps, ...props },
    forwardedRef,
  ) => (
    <PhoneInput
      {...props}
      defaultCountry="gb"
      ref={forwardedRef}
      disableFormatting
      className={twMerge("w-full border-none bg-transparent p-0", className)}
      inputProps={{
        ...inputProps,
        className: twMerge(
          "z-2 h-6 w-full bg-transparent px-2 py-0 font-sans text-base font-normal outline-hidden",
          inputProps?.className,
        ),
      }}
      countrySelectorStyleProps={{
        ...countrySelectorStyleProps,
        buttonClassName: twMerge(
          "-z-0 h-6 border-none bg-transparent px-1",
          countrySelectorStyleProps?.buttonClassName,
        ),
        flagClassName: twMerge(
          "w-10",
          countrySelectorStyleProps?.flagClassName,
        ),
        dropdownStyleProps: {
          ...countrySelectorStyleProps?.dropdownStyleProps,
          className: twMerge(
            "z-50",
            countrySelectorStyleProps?.dropdownStyleProps?.className,
          ),
          listItemClassName: twMerge(
            "px-3 py-2",
            countrySelectorStyleProps?.dropdownStyleProps?.listItemClassName,
          ),
        },
      }}
    />
  ),
);

InputPhoneNumber.displayName = "InputPhoneNumber";
